import LangEnum from '../../../lang/LangEnum';
import { AvailabilityEnum } from '../../products/ProductTypes';
import { CriteriaOperatorEnum } from '../enums/criteriaOperator.enum';
import {
  CatalogCreationCriterionConfig,
  CatalogCreationCriterionEnum,
} from './catalogCreationCriteria.types';

export const CATALOG_CREATION_CRITERIA_OPERATOR_LABELS: Record<CriteriaOperatorEnum, LangEnum> = {
  [CriteriaOperatorEnum.AND]: LangEnum.GLOBAL_AND,
  [CriteriaOperatorEnum.OR]: LangEnum.GLOBAL_OR,
};

export const CATALOG_CREATION_CRITERIA_CONFIGS: CatalogCreationCriterionConfig[] = [
  {
    criterion: CatalogCreationCriterionEnum.AVAILABILITY,
    typeLabel: LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_AVAILABILITY,
    phraseLabel: LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_AVAILABILITY_PHRASE,
    valuesField: 'availability',
    operatorField: 'availabilityCriteriaOperator',
  },
  {
    criterion: CatalogCreationCriterionEnum.COLLECTION,
    typeLabel: LangEnum.GLOBAL_PRODUCT_COLLECTION,
    phraseLabel: LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_COLLECTION_PHRASE,
    valuesField: 'collectionIds',
    operatorField: null,
  },
  {
    criterion: CatalogCreationCriterionEnum.CLASSIFICATION,
    typeLabel: LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_CLASSIFICATION,
    phraseLabel: LangEnum.CATALOGS_CREATION_MODAL_CRITERIA_CLASSIFICATION_PHRASE,
    valuesField: 'classificationIds',
    operatorField: 'classificationCriteriaOperator',
  },
];

export const CATALOG_CREATION_CRITERIA_AVAILABILITIES: AvailabilityEnum[] = [
  AvailabilityEnum.READY_FOR_DELIVERY,
  AvailabilityEnum.FUTURE_STOCK,
  AvailabilityEnum.INFINITE_PRE_ORDER,
  AvailabilityEnum.MATERIAL_PRE_ORDER,
];

export const CATALOG_CREATION_CRITERIA_CHIP_HEIGHT = 22;

export const CATALOG_CREATION_CRITERIA_PHRASE_MAX_LABELS = 2;

export const CATALOG_CREATION_CRITERIA_TOOLTIP_MAX_WIDTH = 280;

export const CATALOG_CREATION_CRITERIA_SEARCH_DEBOUNCE_MS = 400;

export const CATALOG_CREATION_CRITERIA_POPOVER_WIDTH = 320;

export const CATALOG_CREATION_CRITERIA_POPOVER_MAX_HEIGHT = 'min(70vh, 460px)';

export const CATALOG_CREATION_CRITERIA_OPTIONS_MAX_HEIGHT = 240;
